import { CustomerEmailConsumer } from '@cex-newsletter/aws-amplify/src/models';
import { AppHeader as AppHeaderAdmin } from './header-admin';
import { AppHeader as AppHeaderJess } from './header-jess';

export const AppHeader = {
    [CustomerEmailConsumer.JESS_DAVIS]: AppHeaderJess
}[process.env.REACT_APP_CONSUMER] ?? AppHeaderAdmin;
